export default __webpack_public_path__ + "src/assets/status.197991210246a4c844c0895880364563.svg";